import { DateTime } from 'luxon'

import { InsightParameterValueType, InsightParametersType, Entity, isEntity } from '@/types/dashboard-types'

/* Convert parameters to their string equivalents. */
export const toQueryParam = (param: InsightParameterValueType | InsightParameterValueType[]): string => {
  if (typeof param === 'string') {
    return encodeURIComponent(param)
  }
  if (typeof param === 'number') {
    return Number(param).toString()
  }
  if (param instanceof Date) {
    const date = DateTime.fromJSDate(param)
    const isoString = date.toISO({ includeOffset: false })
    return isoString ? isoString.split('.')[0] : ''
  }
  if (param instanceof Array) {
    return param.map((p) => toQueryParam(p)).join(',')
  }
  if (param && isEntity(param as InsightParameterValueType)) {
    return (param as Entity).id.toString()
  }
  return ''
}

/* Given a set of InsightParams, convert them into URL parameters */
export const buildQuery = (params: InsightParametersType) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .reduce<string[]>((arr, [key, value]) => [...arr, `${key}=${toQueryParam(value)}`], [])
    .join('&')

export const buildQueryWithArrays = (params: InsightParametersType) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .reduce<string[]>((arr, [key, value]) => {
      if (value instanceof Array) {
        return [...arr, value.map((v) => `${key}=${toQueryParam(v)}`).join('&')]
      }
      return [...arr, `${key}=${toQueryParam(value)}`]
    }, [])
    .join('&')
